// @flow

import React from "react";
import "./PayPalButton.scss";
import {prepareOrder} from "../../../actions/order";
import OrderProcessingApi from "../../../api/OrderProcessingApi";
import type {PaymentFacilitySessionResponse, PaymentMethod} from "../../../api/PaymentApi";
import PaymentApi from "../../../api/PaymentApi";
import store from "../../../store";
import {PAYMENT_METHODS, PAYMENT_PROVIDER} from "../../../models/PaymentRequests";
import type {PayPalCancelResponse} from "../../../api/PayPalApi";
import {PayPalApproveResponse} from "../../../api/PayPalApi";
import type {Order} from "../../../models/Order";
import {useTranslation} from "react-i18next";
import usePayPalScript from "../../../hooks/usePayPalScript";
import Spinner from "react-spinkit";

interface PayPalButtonProps {
    onOrderCreated: (order: Order) => void;
    onPaymentAssigned: (response: PaymentFacilitySessionResponse) => void;
    onPaymentSuccess: (referenceId: string) => void;
    onPaymentCancelled: (referenceId: string) => void;
    onPaymentFailure: () => void;
}

const PayPalExpressButton = (props: PayPalButtonProps) => {

    const {t} = useTranslation();
    const {PayPalButton, scriptResolved, hasError} = usePayPalScript("authorize");

    const createOrder = () => {
        const orderApi = new OrderProcessingApi();
        const paymentApi = new PaymentApi();
        const order = prepareOrder(store.getState, false);

        return orderApi.createOrder(order)
            .then(resOrder => {
                props.onOrderCreated(resOrder);

                const payment: PaymentMethod = {
                    paymentMethod: PAYMENT_METHODS.PAYPAL_EXPRESS,
                    paymentProvider: PAYMENT_PROVIDER.PAYPAL_EXPRESS
                };
                return paymentApi.assignPaymentForOrder(resOrder.orderNo, payment);
            })
            .then(resPayment => {
                props.onPaymentAssigned(resPayment);
                return resPayment.session.account.referenceId;
            })
            .then(referenceId => {
                return referenceId;
            })
            .catch(err => {
                console.error("PPEX, error in createOrder: ", err);
                props.onPaymentFailure();
                throw err;
            });
    }

	const onApprove = (response: PayPalApproveResponse) => {
        props.onPaymentSuccess(response.paymentID);
	}

	const onError = (err) => {
        console.error("PayPalExpressButton, onError(): ", err);
        props.onPaymentFailure();
	}

	const onCancel = (data: PayPalCancelResponse) => {
		console.error(t("cart.paymentMethods.paymentWindowClosed"));
		alert(t("cart.paymentMethods.paymentWindowClosed"));
        props.onPaymentCancelled(data.orderID);
	};

    if(hasError) {
        console.error("PayPalExpressButton, scriptResolved but has error, cannot render Button");
    }

	return (
        <>
            {(scriptResolved && !hasError) ?
                <PayPalButton
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onError={onError}
                    onCancel={onCancel}
                    style={{ layout: "horizontal", label: "pay", shape: "pill" }}
                />
            : <div style={{ display: "flex", justifyContent: "center" }}>
                    {!hasError &&
                        <Spinner name="ball-beat" className="hpm-spinnerButton"/>
                    }
                </div>
            }
        </>
    );
}

export default PayPalExpressButton;
